<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 智慧通行上 -->
      <el-row>
        <el-col :span="24" class="scene_top">
          <div class="scene_topContent">
            <h1>智慧通行</h1>
            <ul>
              <li>多方式便捷通行</li>
              <li>无接触智能访客管理</li>
              <li>通行在线，主动防护</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <!-- 多方式便捷通行 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space mores">
            <div class="title">
              <h3>多方式便捷通行</h3>
            </div>
            <el-row>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture content_picturesOne">
                    <img src="~@/assets/images/smartPassage2.png" />
                  </div>
                  <p>扫码开门</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture content_picturesTwo">
                    <img src="~@/assets/images/smartPassage3.png" />
                  </div>
                  <p>IC卡片开门</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture content_picturesThree">
                    <img src="~@/assets/images/smartPassage4.png" />
                  </div>
                  <p>远程开门</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="content">
                  <div class="content_picture content_picturesFour">
                    <img src="~@/assets/images/smartPassage5.png" />
                  </div>
                  <p>人脸开门</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 访客管理 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space scene_park">
            <div class="title">
              <h3>访客管理</h3>
            </div>
            <el-row>
              <el-col :span="5">
                <div class="content" style="text-align: right">
                  <h4>
                    访客预约<i style="margin-left: 18px; margin-right: 0"></i>
                  </h4>
                  <p style="width: auto !important">无接触，多端一键预约</p>
                </div>
                <div class="content" style="text-align: right">
                  <h4>
                    访客邀约<i style="margin-left: 18px; margin-right: 0"></i>
                  </h4>
                  <p style="width: auto !important">
                    <i></i>快捷邀约，多设备联动自主授权
                  </p>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="content_picture">
                  <img src="~@/assets/images/smartPassage6.png" />
                </div>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <div class="content" style="text-align: left">
                    <h4><i></i>通行记录</h4>
                    <p style="width: auto !important">
                      人车通行实时记录跟踪，记录有效留存
                    </p>
                  </div>
                </el-row>
                <el-row>
                  <div class="content" style="text-align: left">
                    <h4><i></i>黑名单预警</h4>
                    <p style="width: auto !important">
                      基于人体识别分析流量信息、区域预警、姿态识别
                    </p>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    background: url(~@/assets/images/smartPassage1.png) no-repeat;
    background-size: 100% 100%;
    height: 475px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      position: absolute;
      top: 145px;
      left: 255px;
      text-align: left;
      h1 {
        padding-bottom: 43px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      ul {
        margin-left: 20px;
      }
      ul li {
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        color: #ffffff;
        float: left;
        margin-right: 102px;
      }
    }
  }

  // 访客管理
  .scene_park {
    background: #fafafa !important;
    padding: 81px 96px 104px 131px !important;
    .title {
      h3 {
        margin-bottom: 12px !important;
      }
    }
    .content {
      text-align: left;
      h4 {
        margin: 107px 0 14px 0 !important;
        i {
          width: 10px;
          height: 10px;
          background: #fe5f28;
          border-radius: 50%;
          display: inline-block;
          margin-right: 18px;
        }
      }
      p {
        margin: 0;
      }
    }

    img {
      max-width: 560px;
      max-height: 433px;
    }
  }
  .mores {
    padding: 83px 40px 85px 62px !important;
    .content_picture {
      height: 54px;
      margin-bottom: 10px;
    }

    .content_picturesOne img {
      max-width: 51px;
      max-height: 51px;
    }

    .content_picturesTwo img {
      max-width: 60px;
      max-height: 43px;
    }

    .content_picturesThree img {
      max-width: 41px;
      max-height: 57px;
    }

    .content_picturesFour img {
      max-width: 51px;
      max-height: 61px;
    }
  }

  //访客管理
  .content_space {
    background: #fff;
    padding: 83px 358px 85px 359px;
    h3 {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 71px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHeiLight;
      line-height: 32px;
      width: 208px;
      margin: auto;
    }
    .content {
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #000000;
        margin: 43px 0 44px 0;
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  metaInfo: {
    title: "智慧通行-WIDEN桅灯智能",
    meta: [
      {
        name: "keyWords",
        content:
          "智慧通行,桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
      },
      {
        name: "description",
        content:
          "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能智慧通行可实现多方式便捷通行、无接触智能访客管理、通行在线，主动防护。",
      },
    ],
  },
  data() {
    return {
      tabIndex: "2-5",
    };
  },
  methods: {},
  computed: {},
};
</script>